import { mapGetters } from "vuex";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";

export default {
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getUser",
      "getDataPrivacy",
      "getDetail",
      "getActionRegister",
      "getActionRegisterCounter"
    ])
  },
  mixins: [listFunctions, docRevsModFunctions],
  data() {
    return {
      valid: null
    };
  },
  methods: {
    addActionToActionRegister(action) {
      // INITIAL
      let tempItem = this.defineRelpsAction(action);
      console.log(tempItem);
      // DEFINE LIST + ITEM
      let tempList = this.getActionRegister;
      tempItem.idi = this.getActionRegisterCounter + 1;
      // ADD ITEM
      let obj = Object.assign({}, tempItem);
      let parseobj = JSON.parse(JSON.stringify(obj));
      // eslint-disable-next-line
      let newList = this.appendItemToRegister(parseobj, tempList)
      console.log("HELP");
      // console.log(parseobj);
      // UPDATE LIST
      this.$store.dispatch("changeActionRegister", newList);
      this.$store.dispatch("changeActionRegisterCounter", tempItem.idi);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(3.14, 1); // business mod.
    },
    defineRelpsAction(action) {
      // ADD SOURCE to ACTION RELPS
      let tempItem = this.formRelationshipItem;
      tempItem.fname = this.getUser.pref.select.fname;
      tempItem.ftag = this.getUser.pref.select.ftag;
      tempItem.fdid = this.getUser.pref.select.fdid;
      tempItem.fidg = this.getUser.pref.select.fidg;
      tempItem.fshort = this.getUser.pref.select.fshort;
      if (
        this.getDetail !== null &&
        this.getDetail !== undefined &&
        this.getDetail.basic.tag !== "U1" &&
        this.getDetail.basic.tag !== "B3"
      ) {
        // SET DOC. ITEM
        tempItem.did = action.basic.did;
        tempItem.title = action.basic.title;
        tempItem.tag = action.basic.tag;
        tempItem.idg = action.basic.idg;
        tempItem.did = action.basic.did;
        tempItem.id = action.basic.id;
      }
      return tempItem;
    }
  }
};
